var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"ig",attrs:{"src":"https://leqi-public.oss-cn-shanghai.aliyuncs.com/wechat_applet/collect.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }